<template>
  <div class="shadow-box">
    <div class="shadow-item flex flex_a_c flex_j_c" v-for="(item, index) in dynamicIconList" @click="handleClickIcon(item)"
      :key="index">
      <img class="icon" :src="require(`@/assets/iconfont/${item.icon}.png`)">
      <div class="shadow-label">{{ item.label }}</div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'

export default {
  name: 'fixed-index',
  data () {
    return {
      iconList: [
        {
          icon: 'AI',
          label: '有有AI',
        },
        {
          icon: 'CloudDrive',
          label: '有有云盘',
        },
        {
          icon: 'customerService',
          label: '客服',
          path: '/customerService'
        }
      ],
      isScrolling: false,
      timeoutId: '',
      isAtBottom: false,
      scrollTimer: null,
      scrollContainer: null
    }
  },
  computed: {
    dynamicIconList () {
      const list = [...this.iconList]

      if (this.isAtBottom) {
        list.push({
          icon: 'backWhite',
          label: '顶部',
          path: 'back'
        })
      } else {
        list.push({
          icon: 'bottom',
          label: '底部',
          path: 'bottom'
        })
      }

      return list
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initScrollListener()
    })
  },
   // 在组件销毁时确保清理所有动画
   beforeDestroy () {
    this.destroyScrollListener()
    clearTimeout(this.scrollTimer)
    if (this.timeoutId) {
      window.cancelAnimationFrame(this.timeoutId)
      this.timeoutId = null
    }
  },
  methods: {
    initScrollListener () {
      // let scrollContainerlayoutBox = document.querySelector('.layoutBox')
      // // this.scrollContainer = document.querySelector('.layout')
      // let { scrollHeight, clientHeight } = scrollContainerlayoutBox
      // // 判断是否有垂直滚动条
      // const hasVerticalScrollbar = scrollHeight > clientHeight

      // if (hasVerticalScrollbar) {
      //   this.scrollContainer = scrollContainerlayoutBox
      // } else {
        this.scrollContainer = document.querySelector('.layout')
      // }

      if (this.scrollContainer) {
        this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true })
        // 初始化检查位置
        this.checkScrollPosition()
      }
    },

    destroyScrollListener () {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener('scroll', this.handleScroll)
      }
    },

    handleScroll: function () {
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        this.checkScrollPosition()
      }, 100)
    },

    checkScrollPosition () {
      if (!this.scrollContainer) return

      const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer
      const maxScroll = scrollHeight - clientHeight

      if (scrollTop <= 100) {
        this.isAtBottom = false
      } else {
        this.isAtBottom = scrollTop >= maxScroll - 100
      }
    },

    scrollToTop () {
    if (!this.scrollContainer) return

    // 取消之前的滚动动画
    if (this.timeoutId) {
      window.cancelAnimationFrame(this.timeoutId)
      this.timeoutId = null
    }

    const scrollStep = () => {
      const currentScroll = this.scrollContainer.scrollTop
      if (currentScroll > 0) {
        // 使用更平滑的缓动函数
        const step = Math.max(20, currentScroll / 4)
        this.scrollContainer.scrollTop = currentScroll - step
        this.timeoutId = window.requestAnimationFrame(scrollStep)
      } else {
        this.scrollContainer.scrollTop = 0
        this.isScrolling = false
        this.timeoutId = null
      }
    }

    this.isScrolling = true
    this.timeoutId = window.requestAnimationFrame(scrollStep)
  },

  scrollToBottom () {
    if (!this.scrollContainer) return

    // 取消之前的滚动动画
    if (this.timeoutId) {
      window.cancelAnimationFrame(this.timeoutId)
      this.timeoutId = null
    }

    const scrollStep = () => {
      const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer
      const maxScroll = scrollHeight - clientHeight

      if (scrollTop < maxScroll) {
        // 使用更平滑的缓动函数
        const step = Math.max(20, (maxScroll - scrollTop) / 4)
        this.scrollContainer.scrollTop = Math.min(scrollTop + step, maxScroll)
        this.timeoutId = window.requestAnimationFrame(scrollStep)
      } else {
        this.scrollContainer.scrollTop = maxScroll
        this.isScrolling = false
        this.timeoutId = null
      }
    }

    this.isScrolling = true
    this.timeoutId = window.requestAnimationFrame(scrollStep)
  },

    handleClickIcon (item) {
      switch (item.path) {
        case 'back':
          this.scrollToTop()
          break
        case 'bottom':
          this.scrollToBottom()
          break
        case '/customerService':
          if (Cookie.get('token')) {
            this.$router.push(item.path)
          } else {
            this.$store.commit('SHOW_LOGIN')
          }
          break
        default:
          item.path && this.$router.push(item.path)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.shadow-box {
  width: 64px;
  /* 调整高度以适应动态按钮 */
  height: 244px;
  border-radius: 6px;
  opacity: 1;
  background: #FFFFFF;
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08), 0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
  border: 1px solid #DCDCDC;
  display: grid;
  gap: 4px;
  grid-template-rows: repeat(5, 1fr); /* 调整网格布局 */
}

.shadow-label {
  color: #FFFFFF;
  font-weight: 400;
  font-size: 12px;
  color: rgba(22, 26, 30, 0.6);
  line-height: 20px;
  text-align: center;
}

.icon {
  width: 24px;
  height: 24px;
}

.shadow-item {
  cursor: pointer;
  flex-direction: column;
  height: 56px;

  >.line {
    width: 34px;
    height: 1px;
    opacity: 1;
    margin-top: 17px;
    border: 0.7px solid #EAEAEA;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/index.vue